<template>
  <div>
    <div
      :id="`${activity.sq_code}-top`"
      class="marTML" style="background:#f4f4f4;"
    >
      <p class="widM fntH6 fntL bold padTS padBS" style="color:#002060;">{{ activity.title }} 예약</p>
    </div>
    <!-- <hr :style="isFirst ? { 'border-bottom' : '1px solid #e3e3e3'} : { 'border-top' : '1px solid #e3e3e3'}">-->
    
    <div class="widM marTML">
      <!-- 하나로 나눌 수 없는 마크업이 나와서 부득이하게 2개씩 자름 -->
      <SurveyActivityPair
        v-for="(pair, pairIdx) in pairList"
        :key="`${activity.sq_code}_pair_${pairIdx}`"
        :row-idx="pairIdx"
        :left-side="pair[0]"
        :right-side="pair[1]"
        :activity="activity"
        :show-bottom-hr="pairIdx < pairList.length - 1"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { SURVEY_SYDNEY, ATTENDING_LIST } from '@/store/actions/survey'
import SurveyActivityPair from './SurveyActivityPair.vue'

export default {
  name: 'SurveyActivityParticipant',
  components: {
    SurveyActivityPair,
  },
  props: {
    activity: {
      type: Object,
      required: true
    },
    isFirst: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    ...mapGetters(SURVEY_SYDNEY, {
      attendingList: ATTENDING_LIST
    }),
    pairList() {
      const copyList = [...this.attendingList];
      const length = copyList.length;
      const divide = Math.round(length / 2);
      const pairList = [];
      for(let i = 0; i < divide; i++) {
        pairList.push(copyList.splice(0, 2));
      }
      return pairList;
    },
  },
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/surveys/sydney/components/SurveyActivityParticipant.vue